<a
  class="visually-hidden-focusable au-skip-link"
  href="#main-content"
  data-cy="skip-link"
  >Skip to main content</a
>

<header class="au-header" data-cy="site-header">
  <div class="container h-100 d-flex align-items-center gap-3">
    <!--
      External AU links open in a new tab so a part-filled wizard is never
      discarded by a click on the chrome around it. Matches the in-form
      convention (see the fee-calculator link in the primary-course step).
    -->
    <a
      class="au-logo"
      href="https://www.athabascau.ca"
      target="_blank"
      rel="noopener"
      aria-label="Go to the Athabasca University home page (opens in a new tab)"
      data-cy="au-logo"
    >
      <img
        src="assets/au-logo-horizontal-white.svg"
        alt="Athabasca University"
        width="134"
        height="40"
      />
    </a>
    <span class="au-header-divider" aria-hidden="true"></span>
    <a class="au-site-title" routerLink="/" data-cy="site-title">{{ title }}</a>
  </div>
</header>

<main
  id="main-content"
  class="container py-4"
  tabindex="-1"
  data-cy="main-content"
>
  <router-outlet></router-outlet>
</main>

<footer class="au-footer" data-cy="site-footer">
  <div class="container">
    <img
      src="assets/au-logo-footer-white.svg"
      alt="Athabasca University, Canada's Open University"
      width="143"
      height="32"
      class="d-block mb-3"
    />
    <p class="mb-2" data-cy="footer-copyright">
      &copy; {{ currentYear }} Athabasca University
    </p>
    <ul class="list-inline mb-0">
      <li class="list-inline-item">
        <a
          href="https://www.athabascau.ca/contact/index.html"
          target="_blank"
          rel="noopener"
          data-cy="footer-contact-link"
          >Help and contact<span class="visually-hidden">
            (opens in a new tab)</span
          ></a
        >
      </li>
      <li class="list-inline-item">
        <a
          href="https://www.athabascau.ca/privacy.html"
          target="_blank"
          rel="noopener"
          data-cy="footer-privacy-link"
          >Privacy policy<span class="visually-hidden">
            (opens in a new tab)</span
          ></a
        >
      </li>
    </ul>
  </div>
</footer>
